export async function initSyntaxHighlighting(): Promise<void> {
    const blocks = document.querySelectorAll<HTMLElement>("pre code[class*=\"language-\"]");

    if(!blocks.length) {
        return;
    }

    // Loaded lazily so pages without code blocks don't download the grammars
    const { getSyntaxHighlighter } = await import(
        /* webpackChunkName: "developerStaticHighlighter" */ "@onshopfront/components"
    );
    const highlighter = await getSyntaxHighlighter();

    blocks.forEach(block => {
        const match = /language-(\S+)/.exec(block.className);
        const pre = block.parentElement;

        if(!match || !pre) {
            return;
        }

        try {
            pre.outerHTML = highlighter.codeToHtml(block.textContent ?? "", {
                lang : match[1],
                theme: "github-dark-dimmed",
            });
        } catch {
            // Language isn't registered - leave the block as plain, readable text.
        }
    });
}
